<template>
  <div class="container">
    <h1 class="py-4">仕事一覧</h1>
    <div class="text-right pb-4">
      <router-link class="btn btn-primary" :to="{ name: 'RegisterJob' }">仕事登録</router-link> 
    </div>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="llanglevel">日本語レベル</label>
          <select id="llanglevel" name="level" class="form-control" v-model="langlevel" @change="filter">
            <option v-for="(langLevel , index) in this.langLevels" :key="index" :value="langLevel.code">
              {{ langLevel.level }}
            </option> 
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="lworkPlace">勤務地</label>
          <select id="lworkPlace" name="pref" class="form-control" v-model="workPlace" @change="filter">
            <option value="" >未選択</option>
            <option v-for="(pref , index) in prefs" :key="index" :value="pref.code">
              {{ pref.name }}
            </option>  
          </select>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table text-nowrap">
        <caption class="text-right">グレー背景：非表示データ</caption>
        <tr>
          <th>ID</th>
          <th>概要</th>
          <th>勤務地</th>
          <th>給与</th>
          <th>日本語レベル</th>
          <th>登録日時</th>
          <th>更新日時</th>
        </tr>
        <tr :class="{ 'table-dark': job.dispStatus == 0 }" v-for="(job, index) in this.jobs" :key="index">
          <td class="align-middle"><router-link :to="{ name: 'Job', params: { id: job.id } }">{{ job.id }}</router-link></td>
          <td class="align-middle">{{ job.summary }}</td>
          <td class="align-middle">{{ job.prefInfo.name }}</td>
          <td class="align-middle">{{ job.salaryFrom }} 〜 {{ job.salaryTo }}</td>
          <td class="align-middle text-center">{{ job.japLevel }}</td>
          <td class="align-middle">{{ formatTime(job.createdAt.toDate()) }}</td>
          <td class="align-middle">{{ formatTime(job.updatedAt.toDate()) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import utils from '@/utils/Utils'
import master from '@/constants/MasterEnum'

export default {
  name: "Jobs",
  mixins: [
    utils,
    master
  ],
  data() {
    return {
      db : firebase.firestore(),
      jobs : [],
      targetParams: [],
      workPlace : "",
      langlevel : 9,
    }
  },
  computed : {
    formatTime :function () {
      return function (date) {
          return ("0" + (date.getMonth() + 1)).slice(-2) 
            + "-" 
            + ("0" + date.getDate()).slice(-2) 
            + " " 
            + ("0" + date.getHours()).slice(-2) 
            + ":" 
            + ("0" + date.getMinutes()).slice(-2);
      }
    },
  },
  methods: {
    filter: function () {
      this.jobs = this.targetParams;
      var filteredJobs = [];
      this.jobs.forEach(elem => {
        // 複合条件
        if (this.workPlace && this.langlevel) {
          if (this.eq(elem.prefCode , this.workPlace) &&
              elem.japLevel <= this.langlevel) {
            filteredJobs.push(elem)
          }
        }
        else if (!this.workPlace && !this.langlevel) {
          filteredJobs.push(elem)
        }
        // 単一条件
        else {
          if (this.eq(elem.prefCode, this.workPlace)) {
            filteredJobs.push(elem)
          } 
          if (elem.japLevel <= this.langlevel) {
            filteredJobs.push(elem)
          }
        }
      });
      // 置き換え
      this.jobs = filteredJobs;
    },
    mappingPref: function(place) {
      for (var i in this.prefs) {
        if (this.eq(this.prefs[i].code , place)) {
          return this.prefs[i];
        }
      }
    },
    load: function() {
      this.db.collection("jobs").orderBy("created_at", "desc").orderBy("updated_at", "desc").get().then((query) => {
      // 一旦初期化
        this.jobs = [];
        query.forEach((doc) => {
          var data = doc.data();
          this.jobs.push({
            id : doc.id,
            dispStatus : data.display_status,
            summary : data.summary,
            prefCode : data.pref_code,
            prefInfo: this.mappingPref(data.pref_code),
            salaryFrom : data.salary_from,
            salaryTo : data.salary_to,
            japLevel: data.japanese_level_code,
            createdAt : data.created_at,
            updatedAt : data.updated_at,
          });
        });
        this.targetParams = this.jobs;
      });
    },
  },
  created : function () {
    this.load();
  },



}
</script>